import { createAction } from '../../techstyle-shared/redux-core';

export const trackBuilderTestEntered = createAction(
  'TRACK_BUILDER_TEST_ENTERED'
);
